import { render, staticRenderFns } from "./ReminderOfferEmailTemplate.vue?vue&type=template&id=54b03732&scoped=true"
import script from "./ReminderOfferEmailTemplate.vue?vue&type=script&lang=js"
export * from "./ReminderOfferEmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./ReminderOfferEmailTemplate.vue?vue&type=style&index=0&id=54b03732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b03732",
  null
  
)

export default component.exports